// Update contents object below
const contents = {
  header: 'Intel Corporation', //update with your client name
  logoTooltip: {
    href: 'https://www.intel.com/wonderful', //where the logo click drives to
    copy: '' // tooltip content
  },
  hero: {
    background: 'video', //options: "image" or "video"
    logoPlacement: 'top', //options: "top" or "center"
    title: '5G and the Autonomous Future of Farming',
    copy:
      'Bluewhite and Intel Corporation are leveraging 5G and edge computing to tackle the big challenges facing agriculture.'
  },
  inlinePhotos: {
    size: 'bodyWidth', //options: "fullBleed" or "bodyWidth"
    contents: [
      {
        class: 'photo1',
        caption:
          '“Connectivity and cellular coverage in rural areas are lacking in many parts of the world,” Ascher says. “That’s why we wanted to leverage the 5G ecosystem.” (Photo credit: Bluewhite)'
      },
      {
        class: 'photo2',
        caption:
          'In 2021, the average US farm spans 445 acres. “Wi-fi is going to have a difficult time managing a coverage area of that size,” says Intel’s Caroline Chan. (Photo credit: Bluewhite)'
      },
      {
        class: 'photo3',
        caption: 'Caption: TK –Photocredit: Bogdan Dinca for CORE'
      },
      {
        class: 'photo4',
        caption:
          'Bluewhite and Intel worked with Federated Wireless to deploy a 5G private wireless network alongside tractors using Bluewhite’s autonomous platform at a vineyard in California’s San Joaquin Valley. (Photo credit: Bluewhite)'
      },
      {
        class: 'photo5',
        caption:
          'An aerial view of the vineyard in California’s San Joaquin Valley where the pilot program took place. Alon Ascher hopes that with this new technology will see “the young generation coming back to the farm, as robotic farmers, with pride and joy.” (Photo credit: Bluewhite)'
      }
    ] //add more objects in the array if you have more than one photo
  },
  ctaTooltip: {
    href: 'https://sponsorcontent.cnn.com/interactive/intel/', //where the cta button click drives to
    copy: '' //tooltip content
  }
};

export default contents;
